import { createParseAsEnumListFilter } from '@app/core/list-view/helpers/create-parse-as-enum-list-filter';
import { StationAccessFilterType } from '../components/options';

/**
 * nuqs parser for the status screen `access` query param.
 * Supports a comma-separated list (e.g. `owned,shared`) or a single value.
 * Null/absent means no access filter (show all stations).
 */
export const parseAsStationAccessFilter = createParseAsEnumListFilter(
  Object.values(StationAccessFilterType),
);
